import { type ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import type { ICharacteristics } from '../models/characteristic';

interface ITempChar {
  id: number;
  title: string;
  values: string[];
}

export function productToFilters(product: ProductPageQuery['product']): ICharacteristics {
  const skuList = product.skuList;

  return {
    isShortCharacteristics: false,
    list: [
      {
        subtitle: '',
        values: Array.from(
          skuList
            .reduce((map: Map<number, ITempChar>, sku) => {
              sku.properties?.forEach((prop) => {
                if (map.has(prop.filter.id)) {
                  map.set(prop.filter.id, {
                    ...map.get(prop.filter.id)!,
                    values: [...map.get(prop.filter.id)!.values, prop.name],
                  });
                } else {
                  map.set(prop.filter.id, {
                    id: prop.filter.id || 0,
                    title: prop.filter.title,
                    values: [prop.name],
                  });
                }
              });

              return map;
            }, new Map<number, ITempChar>())
            .values(),
        ).map((item) => ({ name: item.title, value: Array.from(new Set(item.values)).join(', ') })),
      },
    ],
  };
}
